/**
 * Checks if an element is visible with the given DOM selector.
 * 
 * @param selector    The selector to use to get the html element.
 * 
 * @returns           True if the element exists AND is visible, false otherwise.
 */
export function isVisible(selector: string): boolean {
  const element = document.querySelector<HTMLElement>(selector);
  // Based on jQuery's .is(':visible') selector: https://github.com/jquery/jquery/blob/main/src/css/hiddenVisibleSelectors.js
  const isElementVisible = element != null && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  return isElementVisible;
}

/**
 * Shows the given element (bootstrap classes implementation).
 * 
 * @param element     The element to show.
 * @param animate     Set to true for the default animation (uses 400 as default duration), or supply a duration in milliseconds.
 */
export function show(element: HTMLElement, animate?: true | number): void {
  if (typeof animate === 'number') {
    $(element).show(animate);
  } else if (animate === true) {
    $(element).show(400);
  } else {
    $(element).show();
  }
}

/**
 * Hides the given element (bootstrap classes implementation).
 * 
 * @param animate     Set to true for the default animation (uses 400 as default duration), or supply a duration in milliseconds.
 */
export function hide(element: HTMLElement, animate?: true | number): void {
  if (typeof animate === 'number') {
    $(element).hide(animate);
  } else if (animate === true) {
    $(element).hide(400);
  } else {
    $(element).hide();
  }
}
